import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  subscriptions: Subscription = new Subscription();
  actionsRes: any[] | null = [];
  currentModule: string;
  private actionsByModule: Map<string, any[]> = new Map<string, any[]>();
  private loadingByModule: Map<string, Promise<any[]>> = new Map<string, Promise<any[]>>();

  constructor(
    private api: ApiService,
  ) { }


  /**
   * 
   * @param params 
   */
  getActions(params: any): void {
    void this.loadActions(params);
  }

  async loadActions(moduleName: string): Promise<any[]> {
    this.currentModule = moduleName;
    console.log('[PERMISSION_SERVICE] loadActions:start', moduleName);

    if (this.actionsByModule.has(moduleName)) {
      const cachedActions = this.actionsByModule.get(moduleName) || [];
      this.actionsRes = cachedActions;
      console.log('[PERMISSION_SERVICE] loadActions:cache-hit', { moduleName, actionsCount: cachedActions.length });
      return cachedActions;
    }

    const pending = this.loadingByModule.get(moduleName);
    if (pending) {
      console.log('[PERMISSION_SERVICE] loadActions:await-pending', moduleName);
      return pending;
    }

    const request = new Promise<any[]>((resolve) => {
      const subs = this.api.get('getUserActions', moduleName, 'private').subscribe(
        (response: any) => {
          const actions = response != null && response.result != null ? response.result : [];
          this.actionsByModule.set(moduleName, actions);
          this.actionsRes = actions;
          console.log('[PERMISSION_SERVICE] loadActions:api-success', { moduleName, actionsCount: actions.length, actions });
          resolve(actions);
          subs.unsubscribe();
        },
        () => {
          this.actionsByModule.set(moduleName, []);
          // Keep previous permissions during failed reload to avoid navbar flicker.
          console.error('[PERMISSION_SERVICE] loadActions:api-error', moduleName);
          resolve([]);
          subs.unsubscribe();
        }
      );
    }).finally(() => {
      this.loadingByModule.delete(moduleName);
    });

    this.loadingByModule.set(moduleName, request);
    return request;
  }


  /**
   * Проверяем имеется ли в списке действий(actions) запрашиваемое действие(actionVal)
   * @param actionVal допускается имя действия или ID действия
   */
  check(actionName: string, stateBegin?: string): boolean {


    if (this.actionsRes != null && this.actionsRes.length > 0 && stateBegin != null) {

      let indexModule = this.actionsRes.findIndex(val => (val.action == actionName && val.state_begin == stateBegin));

      return indexModule == -1 ? false : true;

    } else if (this.actionsRes != null && this.actionsRes.length > 0) {

      let indexModule = this.actionsRes.findIndex(val => val.action == actionName);
      
      return indexModule == -1 ? false : true;
    }

    return false;
  }
}
